import {api, endpoints} from '@/api'

const state = {
  employeeQuickSumsLoading: false,
  employeeQuickSums: {},
  projectQuickSumsLoading: false,
  projectQuickSums: {},
  filterQuickSumsByProjectSelection: false,
  filterQuickSumsByEmployeeSelection: false
}

const getters = {
  employeeQuickSumsLoading: state => state.employeeQuickSumsLoading,
  employeeQuickSums: state => state.employeeQuickSums,
  projectQuickSumsLoading: state => state.projectQuickSumsLoading,
  projectQuickSums: state => state.projectQuickSums,
  filterQuickSumsByProjectSelection: state => state.filterQuickSumsByProjectSelection,
  filterQuickSumsByEmployeeSelection: state => state.filterQuickSumsByEmployeeSelection
}

function fetchQuickSums (endpoint, varName) {
  return async function ({commit, getters}) {
    const selectedTenant = getters.selectedTenant
    if (selectedTenant !== null) {
      commit(varName+"Loading", {loading: true})
      try {
        const filters = {tenant: selectedTenant, ...getters.selectedPeriodFilter}

        if (varName === "employeeQuickSums" && getters.filterQuickSumsByProjectSelection) {
          filters.project__in=getters.selectedProjects.map(p => p.id)
        }
        else if (varName === "projectQuickSums" && getters.filterQuickSumsByEmployeeSelection) {
          filters.employee__in=getters.selectedEmployees.map(p => p.id)
        }

        if (!getters.profile.show_inactive_employees) {
          filters.inactive = false
        }
        const r = await api(endpoint(), filters, {method: 'GET'})
        if (r.ok) {
          const quicksums = await r.json()
          commit(varName, {quicksums: quicksums[0]})
        } else {
          // TODO: error handling
        }
      } finally {
        commit(varName+"Loading", {loading: false})
      }
    } else {
      commit(varName, {quicksums: {}})
    }
  }
}

const actions = {
  fetchEmployeeQuickSums: fetchQuickSums(
    endpoints.fetch_employee_quicksums,
    "employeeQuickSums"
  ),
  fetchProjectQuickSums: fetchQuickSums(
    endpoints.fetch_project_quicksums,
    "projectQuickSums"
  ),
  updateFilterQuickSumsByProjectSelection ({commit, state}, {value}) {
    if (value && state.filterQuickSumsByEmployeeSelection) {
      commit("filterQuickSumsByEmployeeSelection", {value: false})
    }
    commit("filterQuickSumsByProjectSelection", {value})
  },
  updateFilterQuickSumsByEmployeeSelection ({commit, state}, {value}) {
    if (value && state.filterQuickSumsByProjectSelection) {
      commit("filterQuickSumsByProjectSelection", {value: false})
    }
    commit("filterQuickSumsByEmployeeSelection", {value})
  }
}

const mutations = {
  employeeQuickSumsLoading (state, {loading}) {
    state.employeeQuickSumsLoading = loading
  },
  employeeQuickSums (state, {quicksums}) {
    state.employeeQuickSums = quicksums
  },
  projectQuickSumsLoading (state, {loading}) {
    state.projectQuickSumsLoading = loading
  },
  projectQuickSums (state, {quicksums}) {
    state.projectQuickSums = quicksums
  },
  filterQuickSumsByEmployeeSelection (state, {value}) {
    state.filterQuickSumsByEmployeeSelection = value
  },
   filterQuickSumsByProjectSelection (state, {value}) {
    state.filterQuickSumsByProjectSelection = value
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
